import { twMerge } from "tailwind-merge";
import { Badge } from "../../../../../../components/ui/Badge";

export function TransactionBadgeType({ type }) {
  return (
    <Badge.Root
      outline
      color={type.color}
      className={twMerge("w-full [&>*]:!font-semibold")}>
      <Badge.Text>{type.text}</Badge.Text>
    </Badge.Root>
  )
}
